import { APICfg } from 'services/api/api'
import { findSingleFacet, bundleFacetIds } from 'ui-shared/Facets'
import { experienceParse, experienceWrite } from '../experience'
import { parseFacet } from '../facets'
import { VirtualExperienceToAPI } from './types/api/request-models'
import { APIVirtualExperience } from './types/api/response-models'
import { VirtualExperience } from './types/internal/virtual-models'

// ============
// PARSE
// ============

const virtualParse = (res: APIVirtualExperience): VirtualExperience => {
  const facets = res.facets.map(parseFacet)
  const virtualCategoryFacet = findSingleFacet(
    facets,
    'productFilter',
    'VirtualCategory'
  )

  return {
    ...experienceParse(res),
    virtualCategoryFacet,
  }
}

// ============
// WRITE
// ============

const virtualWrite = async (
  req: VirtualExperience
): Promise<VirtualExperienceToAPI> => {
  const { virtualCategoryFacet, ...reqRest } = req
  const { facets, ...mappedRest } = await experienceWrite(reqRest)

  return {
    ...mappedRest,
    facets: bundleFacetIds(
      ...facets,
      virtualCategoryFacet === '' ? null : virtualCategoryFacet
    ),
  }
}

// ============
// CFG
// ============

const apiCfg: APICfg = {
  endpoint: 'virtualexperiences',
  parse: virtualParse,
  write: virtualWrite,
}

export default apiCfg
